import * as React from 'react';
import { sendHelpEmail } from '../actions/ManageUsersActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';
import { RouteComponentProps } from 'react-router-dom';
import { Heading } from './NavMenu';
import styled from "styled-components";
interface HelpState {
    Name?: string;
    Email?: string;
    Message?: string;
    Submitted?: boolean;
}


const NeedHelp = styled.span`
margin-top:100px;
margin-bottom:4px;
display:block;
    color:#7c7878;

    font-size:18px;
`;

const ContactHere = styled.span`
    color:black;
font-weight:bold;

    font-size:14px;
display:block;
width: 300px;
`;

const Love = styled.span`
display:block;
margin-top:100px;
    color:#7c7878;
    cursor:pointer;
    font-size:18px;
`;

export interface HelpProps {
    sendHelpEmail?(Name, Email, Message);
}

class Help extends React.Component<RouteComponentProps<{}> & HelpProps, HelpState> {
    constructor(props) {
        super(props);

        this.state = {
            Name: "", Email: "", Message: "", Submitted:false
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleMessageChange = this.handleMessageChange.bind(this);


        this.Required = this.Required.bind(this);
    }

    handleSubmit() {
        this.props.sendHelpEmail(this.state.Name, this.state.Email, this.state.Message);
        this.setState({
            Submitted: true
        });
    }
    handleNameChange(event) {
        this.setState({
            Name: event.target.value
        });
    }

    handleEmailChange(event) {
        this.setState({
            Email: event.target.value
        });

    }

    handleMessageChange(event) {
        this.setState({
            Message: event.target.value
        });

    }

    Required() {
        var allEmpty = this.state.Name == "" || this.state.Email == "" || this.state.Message == "";
        return allEmpty;
    }


    public render() {
        return <div className='reports container-fluid'>
            <div className="row">
                <div className="col-md-12">
                    <Heading value='Help and Support' />
                </div>
            </div>
            {!this.state.Submitted &&
            <div className="row">

                <div className="col-md-2">
                    <NeedHelp>Need help?</NeedHelp>
                    <ContactHere><i className="fa fa-envelope"></i> iris-info@umich.edu<br />
                        <i className="fa fa-phone"></i> 734-936-0465<br/>
                    or contact us here!</ContactHere>
                </div>
                <div className="col-md-10">
                        <form className="form-signin helpform">
                            Name:
                        <input type="text" className="form-control" name="name" onChange={this.handleNameChange} value={this.state.Name} placeholder="John Doe" />
                            Email:
                        <input type="text" className="form-control" name="email" onChange={this.handleEmailChange} placeholder="john@doe.com" value={this.state.Email} />
                            <fieldset>
                                <span className=''>Message</span>
                                <textarea onChange={this.handleMessageChange} rows={10} className="form-control" id="message" name="message" value={this.state.Message} placeholder="Hi." />
                            </fieldset>

                            <button className="btn btn-lg btn-primary btn-block" type="button" onClick={() => this.handleSubmit()}>Submit</button>
                            {this.Required() &&
                                <label className='incorrectpassword'>
                                    Please enter all fields.
                            </label>
                            }
                        </form>
                </div>
 
                </div>
            }
            {this.state.Submitted &&
                <div>
                    <h1>Thank you for contacting IRIS.</h1>
                </div>

            }   

        </div>;   
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            sendHelpEmail: sendHelpEmail
        }, dispatch
    )
}
export default connect(
    (state: ApplicationState) => state.userProperties,
    matchDispatchToProps
)(Help);